import React, { useState } from 'react';
import { Card } from '../shared/Card';
// Create a CircularProgressBar component
const CircularProgressBar = ({
  progress,
  total,
  size = 200,
  strokeWidth = 15,
  showTotal = true
}) => {
  // Calculate the radius
  const radius = (size - strokeWidth) / 2;
  // Calculate the circumference
  const circumference = radius * 2 * Math.PI;
  // Calculate the dash offset based on progress
  const dashOffset = circumference - progress / total * circumference;
  // Center position
  const center = size / 2;
  return <div className="relative" style={{
    width: size,
    height: size
  }} data-id="element-1310">
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} data-id="element-1311">
        {/* Background circle */}
        <circle cx={center} cy={center} r={radius} strokeWidth={strokeWidth} stroke="#e5e7eb" fill="none" data-id="element-1312" />
        {/* Progress circle */}
        <circle cx={center} cy={center} r={radius} strokeWidth={strokeWidth} stroke="#3b82f6" fill="none" strokeLinecap="round" strokeDasharray={circumference} strokeDashoffset={dashOffset} transform={`rotate(-90 ${center} ${center})`} data-id="element-1313" />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center" data-id="element-1314">
        <span className="text-5xl font-bold text-gray-800" data-id="element-1315">{progress}</span>
        {showTotal ? <span className="text-lg text-gray-500" data-id="element-1316">/ {total} min</span> : <span className="text-lg text-gray-500" data-id="element-1317">min</span>}
      </div>
    </div>;
};
export const ConsistencyTracker = () => {
  const [timeRange, setTimeRange] = useState('week');
  // Data for different time periods
  const data = {
    day: {
      progress: 25,
      total: 60,
      label: 'Total Minutes today'
    },
    week: {
      progress: 85,
      total: 100,
      label: 'Total Minutes this week'
    },
    month: {
      progress: 320,
      total: 400,
      label: 'Total Minutes this month'
    }
  };
  // Mock data for weekly activity breakdown
  const weeklyData = [{
    day: 'Mon',
    minutes: 10,
    name: 'Monday'
  }, {
    day: 'Tue',
    minutes: 0,
    name: 'Tuesday'
  }, {
    day: 'Wed',
    minutes: 20,
    name: 'Wednesday'
  }, {
    day: 'Thu',
    minutes: 15,
    name: 'Thursday'
  }, {
    day: 'Fri',
    minutes: 0,
    name: 'Friday'
  }, {
    day: 'Sat',
    minutes: 0,
    name: 'Saturday'
  }, {
    day: 'Sun',
    minutes: 0,
    name: 'Sunday'
  }];
  const currentData = data[timeRange];
  return <Card className="p-4" data-id="element-1318">
      <div className="flex justify-between items-center mb-4" data-id="element-1319">
        <h2 className="font-medium text-lg" data-id="element-1320">Consistency Minutes</h2>
        {/* Three-way toggle for Day/Week/Month */}
        <div className="bg-gray-100 rounded-full p-1 flex" data-id="element-1321">
          <button className={`px-4 py-1.5 rounded-full text-sm transition-colors ${timeRange === 'day' ? 'bg-blue-500 text-white' : 'text-gray-600'}`} onClick={() => setTimeRange('day')} data-id="element-1322">
            Day
          </button>
          <button className={`px-4 py-1.5 rounded-full text-sm transition-colors ${timeRange === 'week' ? 'bg-blue-500 text-white' : 'text-gray-600'}`} onClick={() => setTimeRange('week')} data-id="element-1323">
            Week
          </button>
          <button className={`px-4 py-1.5 rounded-full text-sm transition-colors ${timeRange === 'month' ? 'bg-blue-500 text-white' : 'text-gray-600'}`} onClick={() => setTimeRange('month')} data-id="element-1324">
            Month
          </button>
        </div>
      </div>
      {/* Circular Progress Bar */}
      <div className="flex flex-col items-center mb-6" data-id="element-1325">
        <CircularProgressBar progress={currentData.progress} total={currentData.total} showTotal={timeRange !== 'day'} data-id="element-1326" />
        <p className="text-center mt-4 text-gray-500" data-id="element-1327">{currentData.label}</p>
      </div>
      {/* Weekly Activity Breakdown */}
      {timeRange === 'week' && <div data-id="element-1328">
          <h3 className="font-medium text-lg mb-3" data-id="element-1329">This Week's Activity</h3>
          <div className="grid grid-cols-7 gap-2" data-id="element-1330">
            {weeklyData.map(item => <div key={item.day} className="bg-gray-100 rounded-lg p-3 text-center" data-id="element-1331">
                <p className="text-xs text-gray-500 mb-1" data-id="element-1332">{item.day}</p>
                <p className="text-xl font-bold text-gray-800" data-id="element-1333">
                  {item.minutes > 0 ? item.minutes : '—'}
                </p>
              </div>)}
          </div>
        </div>}
      {/* Add Minutes button */}
      <div className="mt-6" data-id="element-1334">
        <button className="w-full bg-blue-500 hover:bg-blue-600 text-white py-2 rounded-full flex items-center justify-center" data-id="element-1335">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2" data-id="element-1336">
            <path d="M12 5v14" data-id="element-1337"></path>
            <path d="M5 12h14" data-id="element-1338"></path>
          </svg>
          Add Minutes
        </button>
      </div>
    </Card>;
};